import NewAppointmentProvider from "../../container/admin/newAppointmen/context/newAppointmentContext";
import NewAppointmentContainer from "../../container/admin/newAppointmen/newAppointmentContainer";

const NewAppointment = (): React.JSX.Element => (
  <NewAppointmentProvider>
    <NewAppointmentContainer />
  </NewAppointmentProvider>
);

export default NewAppointment;
